import { Controller } from "@hotwired/stimulus"
// Used to extend the clickable area.
// You can place data-action="click->anchor#visit" on a higher up element than the actual anchor tag.
export default class extends Controller {
    visit(event) {
        event.preventDefault()
        Turbo.visit(event.currentTarget.querySelector("a").href, { action: "replace" }) // replace is needed to trigger morphing (bug? https://github.com/hotwired/turbo/issues/1158)
    }
}